import { z } from 'zod'
import { schemas } from '@repo/contracts'
import { parseDataOfType } from '@/common/parseDataType'
import { apiErrorHandler } from '../errorHandler'

export type OrgUser = z.infer<typeof schemas.apihttp_OrgUserResponse>
const GetOrgUsersResponseSchema = z.array(schemas.apihttp_OrgUserResponse)

export async function getOrgUsers(): Promise<Array<OrgUser>> {
  const res = await fetch(`${window.location.origin}/api/user/orgUsers`, {
    method: 'GET',
    credentials: 'same-origin'
  })
  await apiErrorHandler(res)
  return parseDataOfType(await res.json(), GetOrgUsersResponseSchema)
}

export type InviteUserRequest = z.infer<typeof schemas.apihttp_InviteUserRequest>

export async function inviteUser(req: InviteUserRequest): Promise<void> {
  const validatedReq = parseDataOfType(req, schemas.apihttp_InviteUserRequest)
  const res = await fetch(`${window.location.origin}/api/user/invite`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(validatedReq)
  })
  await apiErrorHandler(res)
}

export async function removeUser(userId: number): Promise<void> {
  const res = await fetch(`${window.location.origin}/api/user/${userId}`, {
    method: 'DELETE',
    credentials: 'same-origin'
  })
  await apiErrorHandler(res)
}
